import React, { useState, useEffect } from 'react';

const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=800';
const API = process.env.REACT_APP_BACKEND_URL;

// Externe Objektfotos (z. B. onOffice-JPEGs mit 600–900 KB) laufen über den Resize-/WebP-Proxy
export const optimizedPropertyImage = (url, width = 800) =>
  url && /^https:\/\//.test(url) && !url.includes('unsplash.com') ? `${API}/api/social/image?url=${encodeURIComponent(url)}&w=${width}` : url;

// Robustes Immobilien-Bild: faellt bei toten URLs auf weitere Bilder bzw. Platzhalter zurueck
const PropertyImage = ({ immobilie, src, alt, className, width = 800, ...props }) => {
  const sources = [];
  const push = (u) => { if (!u) return; const o = optimizedPropertyImage(u, width); if (o !== u) sources.push(o); sources.push(u); };
  push(src);
  push(immobilie?.hauptbild);
  if (Array.isArray(immobilie?.bilder)) immobilie.bilder.forEach((b) => push(typeof b === 'string' ? b : b?.url));
  sources.push(FALLBACK_IMAGE);
  const unique = [...new Set(sources.filter(Boolean))];

  const [idx, setIdx] = useState(0);

  useEffect(() => {
    setIdx(0);
  }, [src, immobilie?.hauptbild]);

  return (
    <img
      src={unique[Math.min(idx, unique.length - 1)]}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
      onError={() => setIdx((i) => (i < unique.length - 1 ? i + 1 : i))}
      {...props}
    />
  );
};

export default PropertyImage;
